import { modeIds } from '../engine/registry';
import { ACHIEVEMENTS, unlockedIds } from '../state/achievements';
import { loadSlice } from '../state/persistence';
import { seenSlice } from './AchievementWatcher';
import type { StatsState } from '../state/statsLogic';
import { Icon } from './Icon';

export function Achievements({ stats }: { stats: StatsState }) {
  const ids = modeIds();
  const unlocked = unlockedIds(stats, ids, loadSlice(seenSlice));

  return (
    <>
      <p className="cv-faint" style={{ fontSize: 'var(--text-xs)' }}>
        {unlocked.size}/{ACHIEVEMENTS.length} unlocked
      </p>
      <div className="cv-achievements">
      {ACHIEVEMENTS.map((a) => {
        const got = unlocked.has(a.id);
        const prog = !got ? a.progress?.(stats, ids) : undefined;
        return (
          <div key={a.id} className="cv-achievement" data-unlocked={got ? 'true' : undefined}>
            <span className="cv-achievement__icon">
              <Icon name={a.icon} size={20} />
            </span>
            <div className="cv-achievement__text">
              <span className="cv-achievement__name">{a.name}</span>
              <span className="cv-achievement__desc">{a.description}</span>
              {prog && prog.total > 0 ? (
                <div className="cv-achievement__bar" aria-hidden="true">
                  <div style={{ width: `${Math.round((prog.current / prog.total) * 100)}%` }} />
                </div>
              ) : null}
            </div>
            {got ? <Icon name="check" size={16} /> : null}
          </div>
        );
      })}
      </div>
    </>
  );
}
